import { createContext } from 'react'

import { initialChatContext } from './constants'

export const ChatContext =
  createContext<typeof initialChatContext>(initialChatContext)
